/**
 * Readability controls (Task 189, decision 5) — a small, reusable text-comfort
 * toolbar: text size (−/+) and a serif/sans toggle. Presentational; state lives
 * in useReaderPrefs (persisted). Styled with the walnut/gold tokens.
 */
import type { JSX } from "react";
import type { Strings } from "../strings/types";
import type { ReaderPrefsApi } from "./use-reader-prefs";

export function ReadabilityControls(props: { prefs: ReaderPrefsApi; strings: Strings }): JSX.Element {
  const { prefs, strings } = props;
  return (
    <div className="reader-rc" role="group" aria-label={strings.corpusReadabilitySize}>
      <button
        type="button"
        className="reader-rc__btn"
        onClick={prefs.smaller}
        disabled={!prefs.canSmaller}
        aria-label={strings.corpusReadabilitySmaller}
        title={strings.corpusReadabilitySmaller}
      >
        <span className="reader-rc__a reader-rc__a--sm">A</span>
      </button>
      <button
        type="button"
        className="reader-rc__btn"
        onClick={prefs.larger}
        disabled={!prefs.canLarger}
        aria-label={strings.corpusReadabilityLarger}
        title={strings.corpusReadabilityLarger}
      >
        <span className="reader-rc__a reader-rc__a--lg">A</span>
      </button>
      <span className="reader-rc__sep" aria-hidden="true" />
      <button
        type="button"
        className={`reader-rc__btn reader-rc__type ${prefs.prefs.type === "serif" ? "is-serif" : "is-sans"}`}
        onClick={prefs.toggleType}
        aria-label={strings.corpusReadabilityType}
        title={strings.corpusReadabilityType}
        aria-pressed={prefs.prefs.type === "serif"}
      >
        {prefs.prefs.type === "serif" ? "Serif" : "Sans"}
      </button>
    </div>
  );
}
